import http from '~/utils/http'
import type { HttpResponse, RequestConfig } from '~/types/http'
import type {
  GetMyNotificationParams, GetMyNotificationResponse
} from '~/types/notification'

/**
 * 通知列表
 */
export async function getMyNotification(params: GetMyNotificationParams, config?: Partial<RequestConfig>): Promise<HttpResponse<GetMyNotificationResponse>> {
  return http.get('/queue/getMyNotification', {
    params,
    showSuccess: false,
    loading: false,
    ...config
  })
}

/**
 * 未读通知数量
 */
export async function getUnreadNotificationCount(config?: Partial<RequestConfig>): Promise<HttpResponse<number>> {
  return http.get('/queue/getUnreadNum', {
    showSuccess: false,
    loading: false,
    ...config
  })
}

/**
 * 设置已读
 */
export async function markNotificationAsRead(config?: Partial<RequestConfig>): Promise<HttpResponse> {
  return http.get('/queue/setRead', {
    showSuccess: false,
    loading: false,
    ...config
  })
}
